import { FC } from 'react'
import styled, { css } from 'styled-components'

interface IFProps {
  preText: string
  strongText: string
  afterText?: string
  className?: string
}

const PredictionText: FC<IFProps> = ({
  preText,
  strongText,
  afterText,
  className,
}) => {
  return (
    <StyledWrapper className={className}>
      {preText}
      <strong>{strongText}</strong>
      {afterText}
    </StyledWrapper>
  )
}

export default PredictionText

const StyledWrapper = styled.p`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.96px;
    color: ${theme.color.text_1};
    font-family: 'GmarketSansMedium';
    white-space: pre;
    text-align: center;
    margin-bottom: 36px;
    > strong {
      color: ${theme.color.primary_2} !important;
    }
  `}
`
